// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__399rR","inputDescription":"styles_inputDescription__2rvZD"};